"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationProvider = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var axios_1 = __importDefault(require("axios"));
var lodash_1 = require("lodash");
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var MessageContext_1 = __importDefault(require("./MessageContext"));
var UserContext_1 = __importDefault(require("./UserContext"));
// eslint-disable-next-line @typescript-eslint/no-empty-function
var defaultNotifications = {
    applications: {},
    conversations: {},
    invitations: {},
    organizationApplications: {},
    organizationVacancies: {},
    questions: {},
    vacanciesQuestions: {},
};
var defaultContext = {
    notifications: defaultNotifications,
    clearNotification: function () { return undefined; },
};
var NotificationContext = react_1.default.createContext(defaultContext);
function NotificationProvider(_a) {
    var children = _a.children;
    var userId = (0, react_1.useContext)(UserContext_1.default).userId;
    var newMessage = (0, react_1.useContext)(MessageContext_1.default).newMessage;
    var funcNewMessageRef = (0, react_1.useRef)(newMessage);
    var data = (0, react_query_1.useQuery)('notification', function () { return axios_1.default.get('/notifications'); }, {
        enabled: !!userId,
        refetchOnWindowFocus: false,
    }).data;
    var _b = (0, react_1.useState)(defaultNotifications), notifications = _b[0], setNotifications = _b[1];
    var incrementNotification = function (type, id) {
        setNotifications(function (prev) {
            // eslint-disable-next-line no-param-reassign
            prev[type][id] = (prev[type][id] || 0) + 1;
            return Object.assign({}, prev);
        });
    };
    var syncMessage = function (chatId) {
        return axios_1.default.patch("/conversations/".concat(chatId, "/messages-synced"));
    };
    var clearNotification = function (type, id, chatId) {
        if (type !== 'invitations' && chatId) {
            syncMessage(chatId);
        }
        setNotifications(function (prev) {
            // eslint-disable-next-line no-param-reassign
            delete prev[type][id];
            return __assign({}, prev);
        });
    };
    // Set the initial notifications on fetch
    (0, react_1.useEffect)(function () {
        if (data) {
            // Transforming the initial data because if empty in comes as `[]`
            // and if there is anything it comes as `{22: 1, 23: 3}`.
            // Transforming it to an object if it is an array.
            setNotifications((0, lodash_1.mapValues)(data.data, function (d) { return (Array.isArray(d) ? {} : d); }));
        }
    }, [data]);
    (0, react_1.useEffect)(function () {
        funcNewMessageRef.current = newMessage;
    }, [newMessage]);
    (0, react_1.useEffect)(function () {
        if (userId) {
            window.Echo.private("user.conversations.".concat(userId)).listen('ConversationUsersListener', function (_a) {
                var message = _a.message;
                var conversationId = message.conversationId, applicationId = message.applicationId, vacancyId = message.vacancyId, organizationId = message.organizationId, isInvitation = message.isInvitation;
                funcNewMessageRef.current(message);
                if (!organizationId) {
                    incrementNotification('conversations', conversationId);
                    if (isInvitation) {
                        incrementNotification('invitations', conversationId);
                    }
                }
                else {
                    if (applicationId) {
                        incrementNotification('applications', applicationId);
                        incrementNotification('organizationApplications', applicationId);
                    }
                    if (vacancyId) {
                        incrementNotification('organizationVacancies', vacancyId);
                    }
                }
            });
        }
        return function () {
            window.Echo.leave("user.conversations.".concat(userId));
        };
    }, [userId]);
    return (0, jsx_runtime_1.jsx)(NotificationContext.Provider, __assign({ value: { notifications: notifications, clearNotification: clearNotification } }, { children: children }));
}
exports.NotificationProvider = NotificationProvider;
exports.default = NotificationContext;
